const CONSTANTS = {
  CONSTANTS_LOGIN: {
    LOGIN_UPDATE_PASSWORD: "LOGIN_UPDATE_PASSWORD",
    LOGIN_UPDATE_EMAIL: "LOGIN_UPDATE_EMAIL",
    LOGIN_SUBMITTED: "LOGIN_SUBMITTED",
    LOGIN_TOGGLE_LOADING_STATE: "LOGIN_TOGGLE_LOADING_STATE",
    LOGIN_TOGGLE_REMEMBERME_CHECK: "LOGIN_TOGGLE_REMEMBERME_CHECK",
    USER_LOGIN_REQUESTED_SAGA: "USER_LOGIN_REQUESTED_SAGA",
    LOGIN_TOGGLE_LANGUAGE_SAGA: "LOGIN_TOGGLE_LANGUAGE_SAGA",
    LOGIN_TOGGLE_LANGUAGE: "LOGIN_TOGGLE_LANGUAGE",
    USER_LOGIN_SUCCEEDED: "USER_LOGIN_SUCCEEDED",
    USER_LOGIN_FAILED: "USER_LOGIN_FAILED",
    LOGIN_EMAIL_ERROR: "LOGIN_EMAIL_ERROR",
    LOGIN_PASSWORD_ERROR: "LOGIN_PASSWORD_ERROR",
    LOGIN_USERNAME_ERROR: "LOGIN_USERNAME_ERROR",
    LOGIN_ISLOGOUT_SCREEN: "LOGIN_ISLOGOUT_SCREEN",
    USER_LOGOUT: "USER_LOGOUT",
    LOGIN_ISLOGGED_IN: "LOGIN_ISLOGGED_IN",
    LOGIN_ISLANDING_SCREEN: "LOGIN_ISLANDING_SCREEN",
    USER_LOGIN_ROLES: "USER_LOGIN_ROLES",
    IS_APPLICATION_SUBMITTED: "IS_APPLICATION_SUBMITTED",
    IS_APPLICATION_ALREADY_SUBMITTED: "IS_APPLICATION_ALREADY_SUBMITTED",
    APPLICATION_NUMBER: "APPLICATION_NUMBER",
    TOGGLE_IS_PROD: "TOGGLE_IS_PROD",
    TOGGLE_SERVICE_SAGA: "TOGGLE_SERVICE_SAGA",
    CALL_LOGIN_API: "CALL_LOGIN_API",
    UPDATE_LOGIN_RESPONSE: "UPDATE_LOGIN_RESPONSE",
    USER_ROLES_DATA: "USER_ROLES_DATA",
    GET_USER_DIVISION_STATS_CALL: "GET_USER_DIVISION_STATS_CALL",
    GET_USER_DIVISION_STATS_RESPONSE: "GET_USER_DIVISION_STATS_RESPONSE",
    LOGIN_FORGOT_PASSWORD_API_CALL: "LOGIN_FORGOT_PASSWORD_API_CALL",
    LOGIN_FORGOT_PASSWORD_API_RESPONSE: "LOGIN_FORGOT_PASSWORD_API_RESPONSE",
    LOGIN_CONFIRM_PASSWORD_API_CALL: "LOGIN_CONFIRM_PASSWORD_API_CALL",
    LOGIN_CONFIRM_PASSWORD_API_RESPONSE: "LOGIN_CONFIRM_PASSWORD_API_RESPONSE",
  },

  CONSTANTS_TRAILER_MANAGEMENT: {
    GET_TRAILER_MANAGEMENT_API_CALL: "GET_TRAILER_MANAGEMENT_API_CALL",
    EDIT_TRAILER_MANAGEMENT_API_CALL: "EDIT_TRAILER_MANAGEMENT_API_CALL",
    ADD_TRAILER_MANAGEMENT_API_CALL: "ADD_TRAILER_MANAGEMENT_API_CALL",
    TRAILER_ID_UPDATE: "TRAILER_ID_UPDATE",
    TRAILER_STATUS_UPDATE: "TRAILER_STATUS_UPDATE",
    TRAILER_CONDITION_UPDATE: "TRAILER_CONDITION_UPDATE",
    TRAILER_LOCATION_UPDATE: "TRAILER_LOCATION_UPDATE",
    TRAILER_PURCHASE_DATE_UPDATE: "TRAILER_PURCHASE_DATE_UPDATE",
    GET_TRAILER_API_SUCCESS: "GET_TRAILER_API_SUCCESS",
    EDIT_TRAILER_API_SUCCESS: "EDIT_TRAILER_API_SUCCESS",
    ADD_TRAILER_API_SUCCESS: "ADD_TRAILER_API_SUCCESS",
  },

  CONSTANTS_USER_MANAGEMENT: {
    GET_USER_MANAGEMENT_API_CALL: "GET_USER_MANAGEMENT_API_CALL",
    EDIT_USER_MANAGEMENT_API_CALL: "EDIT_USER_MANAGEMENT_API_CALL",
    ADD_USER_MANAGEMENT_API_CALL: "ADD_USER_MANAGEMENT_API_CALL",
    GET_USER_ROLES_MANAGEMENT_API_CALL: "GET_USER_ROLES_MANAGEMENT_API_CALL",
    ADD_USER_ROLES_MANAGEMENT_API_CALL: "ADD_USER_ROLES_MANAGEMENT_API_CALL",
    ADD_USER_ROLES_MANAGEMENT_SUCCESS: "ADD_USER_ROLES_MANAGEMENT_SUCCESS",
    USER_FIRST_NAME_UPDATE: "USER_FIRST_NAME_UPDATE",
    USER_LAST_NAME_UPDATE: "USER_LAST_NAME_UPDATE",
    USER_EMAIL_UPDATE: "USER_EMAIL_UPDATE",
    USER_PASSWORD_UPDATE: "USER_PASSWORD_UPDATE",
    USER_CONFIRM_PASSWORD_UPDATE: "USER_CONFIRM_PASSWORD_UPDATE",
    USER_ROLE_UPDATE: "USER_ROLE_UPDATE",
    GET_USER_API_SUCCESS: "GET_USER_API_SUCCESS",
    EDIT_USER_API_SUCCESS: "EDIT_USER_API_SUCCESS",
    ADD_USER_API_SUCCESS: "ADD_USER_API_SUCCESS",
    GET_USER_ROLES_MANAGEMENT_API_SUCCESS:
      "GET_USER_ROLES_MANAGEMENT_API_SUCCESS",
    GET_USER_DATA_SUCCESS: "GET_USER_DATA_SUCCESS",
    GET_USER_ROLES_MODIFIED: "GET_USER_ROLES_MODIFIED",
    GET_ACTIVE_USER_MANAGEMENT_API_CALL: "GET_ACTIVE_USER_MANAGEMENT_API_CALL",
    GET_ACTIVE_USER_MANAGEMENT_API_SUCCESS:
      "GET_ACTIVE_USER_MANAGEMENT_API_SUCCESS",
  },

  CONSTANTS_DOORS_MANAGEMENT: {
    GET_DOORS_MANAGEMENT_API_CALL: "GET_DOORS_MANAGEMENT_API_CALL",
    EDIT_DOORS_MANAGEMENT_API_CALL: "EDIT_DOORS_MANAGEMENT_API_CALL",
    ADD_DOORS_MANAGEMENT_API_CALL: "ADD_DOORS_MANAGEMENT_API_CALL",
    GET_DOORSBYID_MANAGEMENT_API_CALL: "GET_DOORSBYID_MANAGEMENT_API_CALL",
    GET_DOORSBYID_MANAGEMENT_API_SUCCESS:
      "GET_DOORSBYID_MANAGEMENT_API_SUCCESS",
    GET_DOORS_API_SUCCESS: "GET_DOORS_API_SUCCESS",
    EDIT_DOORS_API_SUCCESS: "EDIT_DOORS_API_SUCCESS",
    ADD_DOORS_API_SUCCESS: "ADD_DOORS_API_SUCCESS",
    DOORS_ID_UPDATE: "DOORS_ID_UPDATE",
    DOORS_NAME_UPDATE: "DOORS_NAME_UPDATE",
    GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL:
      "GET_DOORS_FOR_MOVE_MANAGEMENT_API_CALL",
    GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS:
      "GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS",
    GET_DOORS_LOG_MANAGEMENT_API_CALL: "GET_DOORS_LOG_MANAGEMENT_API_CALL",
    GET_DOORS_LOG_MANAGEMENT_API_SUCCESS:
      "GET_DOORS_LOG_MANAGEMENT_API_SUCCESS",
  },

  CONSTANTS_LOTS_MANAGEMENT: {
    GET_LOTS_MANAGEMENT_API_CALL: "GET_LOTS_MANAGEMENT_API_CALL",
    EDIT_LOTS_MANAGEMENT_API_CALL: "EDIT_LOTS_MANAGEMENT_API_CALL",
    ADD_LOTS_MANAGEMENT_API_CALL: "ADD_LOTS_MANAGEMENT_API_CALL",
    GET_LOTSBYID_MANAGEMENT_API_CALL: "GET_LOTSBYID_MANAGEMENT_API_CALL",
    GET_LOTSBYID_MANAGEMENT_API_SUCCESS: "GET_LOTSBYID_MANAGEMENT_API_SUCCESS",
    GET_LOTS_API_SUCCESS: "GET_LOTS_API_SUCCESS",
    EDIT_LOTS_API_SUCCESS: "EDIT_LOTS_API_SUCCESS",
    ADD_LOTS_API_SUCCESS: "ADD_LOTS_API_SUCCESS",
    LOTS_NAME_UPDATE: "LOTS_NAME_UPDATE",
    DIVISION_NAME_UPDATE: "DIVISION_NAME_UPDATE",
    GET_LOTS_DIVISION_MANAGEMENT_API_CALL:
      "GET_LOTS_DIVISION_MANAGEMENT_API_CALL",
    GET_LOTS_DIVISION_MANAGEMENT_API_SUCCESS:
      "GET_LOTS_DIVISION_MANAGEMENT_API_SUCCESS",
    GET_SPACES_BY_LOTID_MANAGEMENT_API_CALL:
      "GET_SPACES_BY_LOTID_MANAGEMENT_API_CALL",
    GET_SPACES_BY_LOTID_MANAGEMENT_API_SUCCESS:
      "GET_SPACES_BY_LOTID_MANAGEMENT_API_SUCCESS",
    GET_SPACELOGS_MANAGEMENT_API_CALL: "GET_SPACELOGS_MANAGEMENT_API_CALL",
    GET_SPACELOGS_MANAGEMENT_API_SUCCESS:
      "GET_SPACELOGS_MANAGEMENT_API_SUCCESS",
    GET_LOTS_SPACE_DATA: "GET_LOTS_SPACE_DATA",
    GET_LOTS_BY_DIVISION_MANAGEMENT_API_SUCCESS:
      "GET_LOTS_BY_DIVISION_MANAGEMENT_API_SUCCESS",
    GET_LOTS_BY_DIVISION_MANAGEMENT_API_CALL:
      "GET_LOTS_BY_DIVISION_MANAGEMENT_API_CALL",
    GET_LOT_SPACE_API_CALLED: "GET_LOT_SPACE_API_CALLED",
  },

  CONSTANTS_DRIVER_MANAGEMENT: {
    GET_DRIVER_MANAGEMENT_API_CALL: "GET_DRIVER_MANAGEMENT_API_CALL",
    EDIT_DRIVER_MANAGEMENT_API_CALL: "EDIT_DRIVER_MANAGEMENT_API_CALL",
    ADD_DRIVER_MANAGEMENT_API_CALL: "ADD_DRIVER_MANAGEMENT_API_CALL",
    ADD_DRIVER_MANAGEMENT_API_CALL_SUCCESS:
      "ADD_DRIVER_MANAGEMENT_API_CALL_SUCCESS",
    GET_DRIVERBYID_MANAGEMENT_API_CALL: "GET_DRIVERBYID_MANAGEMENT_API_CALL",
    GET_DRIVERBYID_MANAGEMENT_API_SUCCESS:
      "GET_DRIVERBYID_MANAGEMENT_API_SUCCESS",
    GET_DRIVER_API_SUCCESS: "GET_DRIVER_API_SUCCESS",
    EDIT_DRIVER_API_SUCCESS: "EDIT_DRIVER_API_SUCCESS",
    ADD_DRIVER_API_SUCCESS: "ADD_DRIVER_API_SUCCESS",
    DRIVER_FIRST_NAME_UPDATE: "DRIVER_FIRST_NAME_UPDATE",
    DRIVER_LAST_NAME_UPDATE: "DRIVER_LAST_NAME_UPDATE",
  },

  CONSTANTS_TRUCK_MANAGEMENT: {
    GET_TRUCK_MANAGEMENT_API_CALL: "GET_TRUCK_MANAGEMENT_API_CALL",
    EDIT_TRUCK_MANAGEMENT_API_CALL: "EDIT_TRUCK_MANAGEMENT_API_CALL",
    ADD_TRUCK_MANAGEMENT_API_CALL: "ADD_TRUCK_MANAGEMENT_API_CALL",
    ADD_TRUCK_MANAGEMENT_API_CALL_SUCCESS:
      "ADD_TRUCK_MANAGEMENT_API_CALL_SUCCESS",
    GET_TRUCKBYID_MANAGEMENT_API_CALL: "GET_TRUCKBYID_MANAGEMENT_API_CALL",
    GET_TRUCKBYID_MANAGEMENT_API_SUCCESS:
      "GET_TRUCKBYID_MANAGEMENT_API_SUCCESS",
    GET_TRUCK_API_SUCCESS: "GET_TRUCK_API_SUCCESS",
    EDIT_TRUCK_API_SUCCESS: "EDIT_TRUCK_API_SUCCESS",
    ADD_TRUCK_API_SUCCESS: "ADD_TRUCK_API_SUCCESS",
    TRUCK_TYPE_UPDATE: "TRUCK_TYPE_UPDATE",
    TRUCK_BT_ID_UPDATE: "TRUCK_BT_ID_UPDATE",
  },

  CONSTANTS_DIVISIONS_MANAGEMENT: {
    GET_DIVISIONS_MANAGEMENT_API_CALL: "GET_DIVISIONS_MANAGEMENT_API_CALL",
    EDIT_DIVISIONS_MANAGEMENT_API_CALL: "EDIT_DIVISIONS_MANAGEMENT_API_CALL",
    ADD_DIVISIONS_MANAGEMENT_API_CALL: "ADD_DIVISIONS_MANAGEMENT_API_CALL",
    GET_DIVISIONSBYID_MANAGEMENT_API_CALL:
      "GET_DIVISIONSBYID_MANAGEMENT_API_CALL",
    GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS:
      "GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS",
    GET_DIVISIONS_API_SUCCESS: "GET_DIVISIONS_API_SUCCESS",
    EDIT_DIVISIONS_API_SUCCESS: "EDIT_DIVISIONS_API_SUCCESS",
    ADD_DIVISIONS_API_SUCCESS: "ADD_DIVISIONS_API_SUCCESS",
    DIVISION_NAME_UPDATE: "DIVISION_NAME_UPDATE",
    DIVISION_SELECTED: "DIVISION_SELECTED",
  },

  CONSTANTS_OFFSITE_MANAGEMENT: {
    GET_OFFSITE_DATA_API_CALL: "GET_OFFSITE_DATA_API_CALL",
    GET_OFFSITE_API_SUCCESS: "GET_OFFSITE_API_SUCCESS",
    EDIT_OFFSITE_API_CALL: "EDIT_OFFSITE_API_CALL",
    PENDING_OFFSITE_API_CALL: "PENDING_OFFSITE_API_CALL",
    IN_PROGRESS_OFFSITE_API_CALL: "PENDING_OFFSITE_API_CALL",
    GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS:
      "GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS",
    GET_DIVISIONS_API_SUCCESS: "GET_DIVISIONS_API_SUCCESS",
    EDIT_DIVISIONS_API_SUCCESS: "EDIT_DIVISIONS_API_SUCCESS",
    ADD_DIVISIONS_API_SUCCESS: "ADD_DIVISIONS_API_SUCCESS",
    ADD_OFFSITE_API_SUCCESS: "ADD_OFFSITE_API_SUCCESS",
    ADD_OFFSITE_API_CALL: "ADD_OFFSITE_API_CALL",
    DIVISION_NAME_UPDATE: "DIVISION_NAME_UPDATE",
    OFFSITE_COMPLETED_ARRAY: "OFFSITE_COMPLETED_ARRAY",
    OFFSITE_IN_PROGRESS_ARRAY: "OFFSITE_IN_PROGRESS_ARRAY",
    OFFSITE_PENINDING_ARRAY: "OFFSITE_PENINDING_ARRAY",
  },

  CONSTANTS_LOCATION_MANAGEMENT: {
    GET_LOCATION_API_CALL: "GET_LOCATION_API_CALL",
    GET_LOCATION_API_SUCCESS: "GET_LOCATION_API_SUCCESS",
    EDIT_LOCATION_API_CALL: "EDIT_LOCATION_API_CALL",
    EDIT_LOCATION_API_SUCCESS: "EDIT_LOCATION_API_SUCCESS",
    ADD_LOCATION_API_CALL: "ADD_LOCATION_API_CALL",
    ADD_LOCATION_API_SUCCESS: "ADD_DIVISIONS_API_SUCCESS",
    GET_LOCATIONBYID_API_CALL: "GET_LOCATIONBYID_API_CALL",
    GET_LOCATIONBYID_API_SUCCESS: "GET_LOCATIONBYID_API_SUCCESS",
  },

  CONSTANTS_MOVES_MANAGEMENT: {
    GET_MOVES_API_CALL: "GET_MOVES_API_CALL",
    GET_MOVES_API_SUCCESS: "GET_MOVES_API_SUCCESS",
    GET_MOVES_BY_TYPES_API_CALL: "GET_MOVES_BY_TYPES_API_CALL",
    GET_MOVES_BY_TYPES_API_SUCCESS: "GET_MOVES_BY_TYPES_API_SUCCESS",
    GET_DOOR_FOR_MOVES_API_CALL: "GET_DOOR_FOR_MOVES_API_CALL",
    GET_DOOR_FOR_MOVES_API_SUCCESS: "GET_DOOR_FOR_MOVES_API_SUCCESS",
    EDIT_MOVES_API_CALL: "EDIT_MOVES_API_CALL",
    EDIT_MOVES_API_SUCCESS: "EDIT_MOVES_API_SUCCESS",
    ADD_MOVES_API_CALL: "ADD_MOVES_API_CALL",
    ADD_MOVES_API_SUCCESS: "ADD_MOVES_API_SUCCESS",
    UPDATE_MOVES_API_CALL: "UPDATE_MOVES_API_CALL",
    UPDATE_MOVES_API_SUCCESS: "UPDATE_MOVES_API_SUCCESS",
    DELETE_MOVES_API_CALL: "DELETE_MOVES_API_CALL",
    DELETE_MOVES_API_SUCCESS: "DELETE_MOVES_API_SUCCESS",
    GET_MOVESBYID_API_CALL: "GET_MOVESBYID_API_CALL",
    GET_MOVESBYID_API_SUCCESS: "GET_MOVESBYID_API_SUCCESS",
    GET_CONTAINERS_API_CALL: "GET_CONTAINERS_API_CALL",
    GET_CONTAINERS_API_SUCCESS: "GET_CONTAINERS_API_SUCCESS",
    GET_SPACE_FROM_API_CALL: "GET_SPACE_FROM_API_CALL",
    GET_SPACE_FROM_API_SUCCESS: "GET_SPACE_FROM_API__SUCCESS",
    GET_SPACE_TO_API_CALL: "GET_SPACE_TO_API_CALL",
    GET_SPACE_TO_API_SUCCESS: "GET_SPACE_TO_API_SUCCESS",
    CREATE_CONTAINER_API_CALL: "CREATE_CONTAINER_API_CALL",
    CREATE_CONTAINER_API_SUCCESS: "CREATE_CONTAINER_API_SUCCESS",
  },

  CONSTANTS_RURAL_TRAILERS_MANAGEMENT: {
    GET_RURAL_TRAILER_MANAGEMENT_API_CALL:
      "GET_RURAL_TRAILER_MANAGEMENT_API_CALL",
    GET_RURAL_TRAILER_MANAGEMENT_API_SUCCESS:
      "GET_RURAL_TRAILER_MANAGEMENT_API_SUCCESS",
    GET_RURAL_TRAILER_LOGS_API_SUCCESS: "GET_RURAL_TRAILER_LOGS_API_SUCCESS",
    GET_RURAL_TRAILER_LOGS_API_CALL: "GET_RURAL_TRAILER_LOGS_API_CALL",
  },

  CONSTANTS_CORRECTION_MANAGEMENT: {
    GET_CORRECTION_LOG_API_CALL: "GET_CORRECTION_LOG_API_CALL",
    GET_CORRECTION_LOG_API_CALL_SUCCESS: "GET_CORRECTION_LOG_API_CALL_SUCCESS",
    ADD_COORECTION_API_CALL: "ADD_COORECTION_API_CALL",
    ADD_COORECTION_API_CALL_SUCCESS: "ADD_COORECTION_API_CALL_SUCCESS",
  },

  CONSTANTS_WORKSHEET_MANAGEMENT: {
    GET_LOT_CHECK_WORKSHEET_API_CALL: "GET_LOT_CHECK_WORKSHEET_API_CALL",
    GET_LOT_CHECK_WORKSHEET_API_SUCCESS: "GET_LOT_CHECK_WORKSHEET_API_SUCCESS",
    GET_DOOR_CHECK_WORKSHEET_API_CALL: "GET_DOOR_CHECK_WORKSHEET_API_CALL",
    GET_DOOR_CHECK_WORKSHEET_API_SUCCESS:
      "GET_DOOR_CHECK_WORKSHEET_API_SUCCESS",
    DOOR_BULK_API_CALL: "DOOR_BULK_API_CALL",
    DOOR_BULK_API_SUCCESS: "DOOR_BULK_API_SUCCESS",
    SPACE_BULK_API_CALL: "SPACE_BULK_API_CALL",
    SPACE_BULK_API_SUCCESS: "SPACE_BULK_API_SUCCESS",
    LOTS_BULK_API_CALL: "LOTS_BULK_API_CALL",
    LOTS_BULK_API_SUCCESS: "LOTS_BULK_API_SUCCESS",

    DIVISION_BULK_API_CALL: "DIVISION_BULK_API_CALL",
    DIVISION_BULK_API_SUCCESS: "DIVISION_BULK_API_SUCCESS",

    USER_BULK_API_CALL: "USER_BULK_API_CALL",
    USER_BULK_API_SUCCESS: "USER_BULK_API_SUCCESS",

    TRAILER_BULK_API_CALL: "TRAILER_BULK_API_CALL",
    TRAILER_BULK_API_SUCCESS: "TRAILER_BULK_API_SUCCESS",

    CREATE_REPORTS_API_CALL: "CREATE_REPORTS_API_CALL",
    CREATE_REPORTS_API_SUCCESS: "CREATE_REPORTS_API_SUCCESS",

    UPDATE_PDF_DATA: "UPDATE_PDF_DATA",
  },

  CONSTANTS_DEPARTMENT_MANAGEMENT: {
    GET_DEPARTMENT_API_CALL: "GET_DEPARTMENT_API_CALL",
    GET_DEPARTMENT_API_SUCCESS: "GET_DEPARTMENT_API_SUCCESS",
    EDIT_DEPARTMENT_API_CALL: "EDIT_DEPARTMENT_API_CALL",
    EDIT_DEPARTMENT_API_SUCCESS: "EDIT_DEPARTMENT_API_SUCCESS",
    DELETE_DEPARTMENT_API_CALL: "DELETE_DEPARTMENT_API_CALL",
    DELETE_DEPARTMENT_API_SUCCESS: "DELETE_DEPARTMENT_API_SUCCESS",
    ADD_DEPARTMENT_API_CALL: "ADD_DEPARTMENT_API_CALL",
    ADD_DEPARTMENT_API_SUCCESS: "ADD_DEPARTMENT_API_SUCCESS",
  },

  CONSTANTS_NOTIFICATIONS_MANAGEMENT: {
    GET_NOTIFICATIONS_API_CALL: "GET_NOTIFICATIONS_API_CALL",
    GET_NOTIFICATIONS_API_SUCCESS: "GET_NOTIFICATIONS_API_SUCCESS",
    EDIT_NOTIFICATIONS_API_CALL: "EDIT_NOTIFICATIONS_API_CALL",
    EDIT_NOTIFICATIONS_API_SUCCESS: "EDIT_NOTIFICATIONS_API_SUCCESS",
  },

  CONSTANTS_USER_ROLES: {
    ADMIN: "ADMIN",
    RHADMIN: "RHADMIN",
    DISPATCH: "DISPATCH",
    RHUSER: "RHUSER",
    VIEWONLY: "VIEWONLY",
    DRIVER: "DRIVER",
    TRAILERADMIN: "TRAILERADMIN",
    USERADMIN: "USERADMIN",
  },
  CONSTANTS_USER_ROLES_HEADER_NAME: {
    ADMIN: "SUPER ADMIN",
    RHADMIN: "ADMIN",
    DISPATCH: "DISPATCH",
    RHUSER: "USER",
    VIEWONLY: "VIEWONLY",
    DRIVER: "DRIVER",
    TRAILERADMIN: "TRAILERADMIN",
    USERADMIN: "USERADMIN",
  },
};

export default CONSTANTS;
